import Yup from 'utils/validations';

export const addPaymentMethodSchema = Yup.object().shape({
  cardHolder: Yup.string().max(255).required(),
  address: Yup.string().max(255).required(),
  city: Yup.string().max(255).required(),
  state: Yup.string().max(255).required(),
  zip: Yup.string().max(255).required(),
});
